var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-jl-links"},[_c('o-link',{staticClass:"o-jl-links__link",attrs:{"to":{name: 'register'}}},[_vm._v("Join")]),_c('o-link',{staticClass:"o-jl-links__link",attrs:{"to":{name: 'login'}}},[_vm._v("Login")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }